import { render, staticRenderFns } from "./DocumentDetailsInfo.vue?vue&type=template&id=2de42840&"
import script from "./DocumentDetailsInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentDetailsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DocumentDetailsInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports